<div class="bkg">

    <div class="concat-div">
        <div class="header" data-aos="zoom-in-up">או שאפשר לתקשר איתנו ישירות:</div>
        <div class="row text-wrap">
            <span class="col-4" data-aos="fade-up">
                <span class="icon-new-whatsapp"></span>
                058-769-3131⁩
            </span>
            <span class="col-4" data-aos="fade-up">
                <span class="icon-new-phone"></span>
                052-769-3131⁩
            </span>
            <span class="col-4" data-aos="fade-up">
                <span class="icon-new-mail2"></span>
                x93131@gmail.com
            </span>
        </div>
    </div>
    <div class="footer-text">
        <p data-aos1="flip-up">
            אוהבים להתקבץ כולם יחד, ממש פיזי? <br>
            בקרו באתר מלחמת מוחות וגלו <br>
            איך זה לשחק טריוויה באקסטרים:
        </p>
        <div class="icon-wrap row">
            <a class="col-4 icon-new-facebook2" data-aos="flip-up" href="https://www.facebook.com/milchemetmochot/"
                target="_blank"></a>
            <a class="col-4 icon-new-youtube" data-aos="flip-up"
                href="https://www.youtube.com/channel/UCCYzWsGklOIvIgsfghRtY_A" target="_blank"></a>
            <a class="col-4 icon-new-earth" data-aos="flip-up" href="https://milchemet.co.il/"
                target="_blank"></a>
        </div>

    </div>
</div>